import React from "react";

const Loader = () => {
  return (
    <div className="app-loader">
      <h1>FryumTech Solutions</h1>
      <p>"Your Growth, Our Success"</p>
    </div>
  );
};

export default Loader;
